/**
 * This file was auto-generated by Fern from our API Definition.
 */
import * as core from "../../../../core";
import { JsonPatchOperation } from "./JsonPatchOperation";
export const SpaceDraftMergeOperation = core.serialization.object({
    action: core.serialization.string(),
    id: core.serialization.string().optional(),
    mergeId: core.serialization.string().optional(),
    jsonPatch: core.serialization.list(JsonPatchOperation).optional(),
});
